export enum Symbols {
    LEFT_ARROW = '\u2190',
    EM_DASH = '\u2014',
    TRIANGLE_UP = '\u25B2',
    TRIANGLE_DOWN = '\u25BC',
}
